import * as THREE from 'three';
import * as marietta from '../..';
import { SVGSprite } from '../flash/display';
import { Stage } from '../model';
import * as graphicLibs from '../../graphicLibs/index';
import { PointCollection } from '../collection';
import { BUILDING_TYPE_MANSION, CONTROL_ACTIONMODE, ITEM_MODE_NO } from '../Constants';
import { SnapElemnt } from '../manager/SnapManager';
import { CalculationUtil } from '../util';

/**
 * 部屋ドラッグ入力を作成するためのクラス
 */
class ItemControllerRoomDragInput {
  rect: Element;

  dragImage: Element;

  dotList: marietta.core.Point[] = [];

  startPoint: marietta.core.Point;

  endPoint: marietta.core.Point;

  horizontalText1: marietta.webcad.control.parts.DragInputText;

  verticalText1: marietta.webcad.control.parts.DragInputText;

  horizontalText2: marietta.webcad.control.parts.DragInputText;

  verticalText2: marietta.webcad.control.parts.DragInputText;

  sizeText: marietta.webcad.control.parts.SizeText;

  floor: number;

  tarLayer: marietta.webcad.layer.FloorShitaeLayer;

  private static _instance: ItemControllerRoomDragInput = null;

  public spt: SVGSprite;

  public snapSpt: SVGSprite;

  private moveMouseEvent: MouseEvent;

  private isSnapStartPoint: boolean = false;

  snapList: SnapElemnt[];

  /**
   * コンストラクタ
   */
  constructor() {
    if (ItemControllerRoomDragInput._instance) {
      throw new Error('must use the getInstance.');
    }
    // this.initMe();
  }

  /**
   * シングルトン
   */
  static getInstance(): ItemControllerRoomDragInput {
    if (ItemControllerRoomDragInput._instance === null) {
      ItemControllerRoomDragInput._instance = new ItemControllerRoomDragInput();
    }
    ItemControllerRoomDragInput._instance.initMe();
    return ItemControllerRoomDragInput._instance;
  }

  /**
   * 初期化
   */
  initMe() {
    this.floor = marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor;
    // 作成する階
    this.tarLayer = marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(this.floor, true) as marietta.webcad.layer.FloorShitaeLayer;

    const stage = document.querySelector('#layerGroup');
    let ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isMobile || ua.isTablet) {
      stage.addEventListener('touchstart', this.startDrag, { passive: false });
    } else {
      stage.addEventListener('mousedown', this.startDrag);
    }

    this.isSnapStartPoint = false;
    if (marietta.webcad.WebCADGlobal.webcad2Dmanager.isSnap() === false) {
      if (ua.isMobile || ua.isTablet) {
        stage.addEventListener('touchmove', this.followMouse, { passive: false });
      } else {
        stage.addEventListener('mousemove', this.followMouse);
      }
      this.isSnapStartPoint = true;
      const viewObj = document.createElementNS('http://www.w3.org/2000/svg', 'g');
      const tar: SVGRectElement = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
      viewObj.appendChild(tar);
      tar.setAttribute('width', '50px');
      tar.setAttribute('height', '50px');
      tar.setAttribute('x', '-25');
      tar.setAttribute('y', '-25');
      tar.setAttribute('opacity', '0');
      viewObj.setAttribute('id', 'controller_pen');
      this.tarLayer.viewObj.appendChild(viewObj);
      this.snapSpt = new SVGSprite(viewObj);
      this.snapList = [];
      this.snapList = marietta.webcad.WebCADGlobal.snapManager.snapElements.map((m: SnapElemnt) => m);
      marietta.webcad.WebCADGlobal.snapManager.createSnapGuide(this.tarLayer);
      const scope: ItemControllerRoomDragInput = this;
      this.snapSpt.onEnterFrame = (): void => {
        if (scope.moveMouseEvent != null && scope.isSnapStartPoint) {
          scope.followMouseHandler();
        }
      };
    }
    ua = null;
  }

  /**
   * マウス追従
   */
  followMouse = (e: MouseEvent & TouchEvent) => {
    if (marietta.webcad.WebCADGlobal.userAgentManager.isMobile || marietta.webcad.WebCADGlobal.userAgentManager.isTablet) {
      e.preventDefault();
    }

    this.moveMouseEvent = e;
    if (marietta.webcad.WebCADGlobal.userAgentManager.isMobile || marietta.webcad.WebCADGlobal.userAgentManager.isTablet) {
      if (e.touches.length >= 2) {
        return;
      }
      e.preventDefault();
      Stage.refreshStageMouse(<any>e);
    }
  };

  followMouseHandler() {
    // e.preventDefault();
    const newPoint: marietta.core.Point = new marietta.core.Point(this.tarLayer.spt.mouseX, this.tarLayer.spt.mouseY);
    if (marietta.webcad.WebCADGlobal.webcad2Dmanager.isSnap() === false) {
      marietta.webcad.WebCADGlobal.snapManager.hideAll();
      const snap = marietta.webcad.WebCADGlobal.snapManager.nearestSnap(this.snapList, newPoint.x, newPoint.y);
      if (snap) {
        newPoint.x = snap.point.x;
        newPoint.y = snap.point.y;
      }
      this.snapSpt.x = newPoint.x;
      this.snapSpt.y = newPoint.y;
      this.snapSpt.update();
    }
  }

  /**
   * ドラッグ開始
   */
  startDrag = (e: MouseEvent) => {
    this.isSnapStartPoint = false;
    this.moveMouseEvent = null;
    // ドラッグモードでなければ終了
    if (marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode !== CONTROL_ACTIONMODE.ACTIONMODE_INPUT_DRAG_ROOM) return;
    const floor: number = marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor;
    // 作成する階
    const tarLayer: marietta.webcad.layer.FloorShitaeLayer = marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(floor, true) as marietta.webcad.layer.FloorShitaeLayer;
    // ドラッグイメージの初期化
    if (document.getElementById('dragImage')) {
      document.getElementById('dragImage').remove();
    }
    if (this.snapSpt && this.snapSpt.element) {
      this.snapSpt.deleteEnterFrame();
      this.snapSpt.element.remove();
    }
    if (this.spt && this.spt.element) {
      this.spt.deleteEnterFrame();
      this.spt.element.remove();
    }
    // ドラッグイメージの作成
    this.dragImage = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    this.dragImage.setAttribute('id', 'dragImage');
    tarLayer.viewObj.appendChild(this.dragImage);
    this.spt = new SVGSprite(this.dragImage);

    let ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isMobile || ua.isTablet) {
      Stage.refreshStageMouse(<any>e);
      e.stopImmediatePropagation();
      e.preventDefault();
    }

    // 開始地点の座標
    this.startPoint = new marietta.core.Point(this.tarLayer.spt.mouseX, this.tarLayer.spt.mouseY);
    if (marietta.webcad.WebCADGlobal.webcad2Dmanager.isSnap() === false) {
      const snap = marietta.webcad.WebCADGlobal.snapManager.nearestSnap(this.snapList, this.startPoint.x, this.startPoint.y); // 最も近いスナップを取得する
      if (snap) {
        this.startPoint.x = snap.point.x;
        this.startPoint.y = snap.point.y;
      }
    } else {
      const snapUnit = marietta.webcad.WebCADGlobal.webcad2Dmanager.snapUnitPix;
      this.startPoint.x = Math.round(this.startPoint.x / snapUnit) * snapUnit;
      this.startPoint.y = Math.round(this.startPoint.y / snapUnit) * snapUnit;
    }
    // ドラッグエリアの色取得
    const info: marietta.webcad.collection.ItemInfoCollection = new marietta.webcad.collection.ItemInfoCollection();
    info.id = String((<HTMLInputElement>document.getElementById('roomInputMenuItems').querySelector('input[type="radio"]:checked')).value);
    const defaultRoomSetting = marietta.webcad.WebCADGlobal.getRoomConfig(info.id);
    // ドラッグエリアの作成
    this.rect = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    this.rect.setAttribute('fill', defaultRoomSetting.color);
    this.rect.setAttribute('fill-opacity', '1');

    switch (defaultRoomSetting.wallType) {
      case 0:
        break;
      default:
        this.rect.setAttribute('stroke', marietta.webcad.WebCADGlobal.getColorForWallType(defaultRoomSetting.wallType).color);
        this.rect.setAttribute('stroke-width', '10');
        break;
    }
    if (info.id.substring(0, 3) === 'bem') {
      this.rect.setAttribute('fill-opacity', '0');
      this.rect.setAttribute('stroke', defaultRoomSetting.color);
      this.rect.setAttribute('stroke-width', '2');
      this.rect.setAttribute('stroke-dasharray', '2.0251,2.0251');
    }
    this.rect.setAttribute('id', 'dragRect');
    this.dragImage.appendChild(this.rect);

    // テキスト
    this.horizontalText1 = new marietta.webcad.control.parts.DragInputText(this.spt, 1);
    this.horizontalText1.firstDot = this.startPoint;
    this.horizontalText1.secondDot = new marietta.core.Point(this.tarLayer.spt.mouseX, this.startPoint.y);
    this.horizontalText1.align = 'top';
    this.horizontalText1.updateTransforms(false);
    this.horizontalText2 = new marietta.webcad.control.parts.DragInputText(this.spt, 1);
    this.horizontalText2.firstDot = new marietta.core.Point(this.startPoint.x, this.tarLayer.spt.mouseY);
    this.horizontalText2.secondDot = new marietta.core.Point(this.tarLayer.spt.mouseX, this.tarLayer.spt.mouseY);
    this.horizontalText2.updateTransforms(false);
    this.horizontalText2.align = 'bottom';

    this.verticalText1 = new marietta.webcad.control.parts.DragInputText(this.spt, 2);
    this.verticalText1.firstDot = this.startPoint;
    this.verticalText1.secondDot = new marietta.core.Point(this.startPoint.x, this.tarLayer.spt.mouseY);
    this.verticalText1.updateTransforms(false);
    this.verticalText1.align = 'left';
    this.verticalText2 = new marietta.webcad.control.parts.DragInputText(this.spt, 2);
    this.verticalText2.firstDot = new marietta.core.Point(this.tarLayer.spt.mouseX, this.startPoint.y);
    this.verticalText2.secondDot = new marietta.core.Point(this.tarLayer.spt.mouseX, this.tarLayer.spt.mouseY);
    this.verticalText2.updateTransforms(false);
    this.verticalText2.align = 'right';

    this.sizeText = new marietta.webcad.control.parts.SizeText(this.spt);
    this.sizeText.firstDot = this.startPoint;
    this.sizeText.secondDot = this.endPoint;
    this.sizeText.updateTransforms();

    if (info.id === 'col01_01' || info.id === 'bem01_01') {
      this.horizontalText1.hide();
      this.verticalText1.hide();
      this.horizontalText2.hide();
      this.verticalText2.hide();
      this.sizeText.hide();
    }

    if (ua.isMobile || ua.isTablet) {
      document.addEventListener('touchmove', this.moveDrag, { passive: false });
      document.addEventListener('touchend', this.endDrag, { passive: false });
    } else {
      document.addEventListener('mousemove', this.moveDrag);
      document.addEventListener('mouseup', this.endDrag);
    }

    const scope: ItemControllerRoomDragInput = this;
    // comment k.kubonaka
    // mousemoveハンドラのタイミングで描画処理を行うとIEで極端にFPS低下するため
    // 実際の描画処理は、SpriteのEnterFrame(setTimeOut)ベースで行う
    this.spt.onEnterFrame = (): void => {
      if (scope.moveMouseEvent != null) {
        scope.moveDragHandler();
      }
    };
    ua = null;
  };

  /**
   *ドラッグ中の制御
   */
  private moveDragHandler() {
    // 終了地点の座標
    this.endPoint = new marietta.core.Point(this.tarLayer.spt.mouseX, this.tarLayer.spt.mouseY);
    if (marietta.webcad.WebCADGlobal.webcad2Dmanager.isSnap() === false) {
      const snap = marietta.webcad.WebCADGlobal.snapManager.nearestSnap(this.snapList, this.endPoint.x, this.endPoint.y); // 最も近いスナップを取得する
      if (snap) {
        this.endPoint.x = snap.point.x;
        this.endPoint.y = snap.point.y;
      }
    } else {
      const snapUnit = marietta.webcad.WebCADGlobal.webcad2Dmanager.snapUnitPix;
      this.endPoint.x = Math.round(this.endPoint.x / snapUnit) * snapUnit;
      this.endPoint.y = Math.round(this.endPoint.y / snapUnit) * snapUnit;
    }

    // テキスト
    this.horizontalText1.secondDot = new marietta.core.Point(this.endPoint.x, this.startPoint.y);
    this.horizontalText1.updateTransforms(false);
    this.horizontalText2.firstDot = new marietta.core.Point(this.startPoint.x, this.endPoint.y);
    this.horizontalText2.secondDot = new marietta.core.Point(this.endPoint.x, this.endPoint.y);
    this.horizontalText2.updateTransforms(false);

    this.verticalText1.secondDot = new marietta.core.Point(this.startPoint.x, this.endPoint.y);
    this.verticalText1.updateTransforms(false);
    this.verticalText2.firstDot = new marietta.core.Point(this.endPoint.x, this.startPoint.y);
    this.verticalText2.secondDot = new marietta.core.Point(this.endPoint.x, this.endPoint.y);
    this.verticalText2.updateTransforms(false);

    this.sizeText.firstDot = this.startPoint;
    this.sizeText.secondDot = this.endPoint;
    this.sizeText.updateTransforms();

    // ドラッグエリアの座標作成
    let pathList = `M ${this.startPoint.x} ${this.startPoint.y} `;
    pathList += `L ${this.startPoint.x} ${this.endPoint.y} `;
    pathList += `L ${this.endPoint.x} ${this.endPoint.y} `;
    pathList += `L ${this.endPoint.x} ${this.startPoint.y} `;
    pathList += 'Z';
    this.rect.setAttribute('d', pathList);
  }

  /**
   * ドラッグ中の制御
   */
  moveDrag = (e: MouseEvent & TouchEvent) => {
    e.preventDefault();
    const ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isMobile || ua.isTablet) {
      e.preventDefault();
      e.stopPropagation();
    }
    this.moveMouseEvent = e;
    // pad スマホ用タッチ座標修正
    if (ua.isMobile || ua.isTablet) {
      if (e.touches.length >= 2) {
        return;
      }
      e.preventDefault();
      Stage.refreshStageMouse(<any>e);
    }
  };

  /**
   * ドラッグ終了
   */
  endDrag = (e: MouseEvent) => {
    e.preventDefault();
    this.spt.deleteEnterFrame();
    this.moveMouseEvent = null;

    let ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isMobile || ua.isTablet) {
      document.removeEventListener('touchmove', this.moveDrag);
      document.removeEventListener('touchend', this.endDrag);
    } else {
      document.removeEventListener('mousemove', this.moveDrag);
      document.removeEventListener('mouseup', this.endDrag);
    }
    ua = null;

    // 終了地点の座標
    this.endPoint = new marietta.core.Point(this.tarLayer.spt.mouseX, this.tarLayer.spt.mouseY);

    if (marietta.webcad.WebCADGlobal.webcad2Dmanager.isSnap() === false) {
      const snap = marietta.webcad.WebCADGlobal.snapManager.nearestSnap(this.snapList, this.endPoint.x, this.endPoint.y); // 最も近いスナップを取得する
      if (snap) {
        this.endPoint.x = snap.point.x;
        this.endPoint.y = snap.point.y;
      }
    } else {
      const snapUnit = marietta.webcad.WebCADGlobal.webcad2Dmanager.snapUnitPix;
      this.endPoint.x = Math.round(this.endPoint.x / snapUnit) * snapUnit;
      this.endPoint.y = Math.round(this.endPoint.y / snapUnit) * snapUnit;
    }

    // 開始地点と終了地点が等しいなら何もしない
    if (this.startPoint.x === this.endPoint.x || this.startPoint.y === this.endPoint.y) {
      this.clean();
    } else {
      // 座標の保持
      this.dotList = [this.startPoint, new marietta.core.Point(this.startPoint.x, this.endPoint.y), this.endPoint, new marietta.core.Point(this.endPoint.x, this.startPoint.y)];
      // 形状作成終了
      this.endMakeShape();
    }
  };

  // イベント削除
  removeEventListeners() {
    const stage = document.querySelector('#layerGroup');
    const ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isMobile || ua.isTablet) {
      stage.removeEventListener('touchstart', this.startDrag);
      document.removeEventListener('touchmove', this.moveDrag);
      stage.removeEventListener('touchmove', this.followMouse);
      document.removeEventListener('touchend', this.endDrag);
    } else {
      document.removeEventListener('mousemove', this.moveDrag);
      stage.removeEventListener('mousemove', this.followMouse);
      document.removeEventListener('mouseup', this.endDrag);
      stage.removeEventListener('mousedown', this.startDrag);
    }
  }

  /** 形状作成の終了 */
  public endMakeShape() {
    const selectedItemId = this.getSelectedRoomItemId();
    const shouldDivideRoom = this.shouldDivideRoom(selectedItemId);

    if (this.isMansionRoomDivisionMode(shouldDivideRoom)) {
      this.handleMansionRoomCreation();
    } else {
      this.handleRoomCreation();
    }

    this.finalizeShapeCreation();
  }

  /** 選択中の部屋ID取得 */
  private getSelectedRoomItemId(): string {
    const checked = document.getElementById('roomInputMenuItems')?.querySelector<HTMLInputElement>('input[type="radio"]:checked');

    if (!checked) {
      throw new Error('部屋種類が選択されていません。');
    }

    return checked.value;
  }

  /** 分割する部屋IDかどうかboolを返す */
  private shouldDivideRoom(selectedItemId: string): boolean {
    return selectedItemId !== 'col01_01' && selectedItemId !== 'bem01_01';
  }

  /** マンションモード&分割する部屋IDであれば分割を実施 */
  private isMansionRoomDivisionMode(shouldDivideRoom: boolean): boolean {
    return (
      marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION &&
      shouldDivideRoom
    );
  }

  /** マンションモードの部屋作成関数 */
  private handleMansionRoomCreation() {
    marietta.webcad.WebCADGlobal.webcad2Dmanager.isParsingObjects = true;
    // 現在の階の頂点リストを取得する
    const roomList: marietta.webcad.item.Room[] = [
      ...marietta.webcad.WebCADGlobal.layerGroup.getTypeLayerInFloorLayer(marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor, ITEM_MODE_NO.MODE_ROOM_NO).getAllChildren(),
      ...marietta.webcad.WebCADGlobal.layerGroup.getTypeLayerInFloorLayer(marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor, ITEM_MODE_NO.MODE_ROOMDOWN1_NO).getAllChildren(),
      ...marietta.webcad.WebCADGlobal.layerGroup.getTypeLayerInFloorLayer(marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor, ITEM_MODE_NO.MODE_ROOMDOWN2_NO).getAllChildren(),
    ];
    const allPointList: any[] = marietta.webcad.WebCADGlobal.webcad2Dmanager.getAllRoomPointList(roomList);

    marietta.webcad.WebCADGlobal.scene = new graphicLibs.Scene();
    if (allPointList.length > 0) {
      allPointList.forEach((pList: any) => {
        marietta.webcad.WebCADGlobal.scene.add(new graphicLibs.objects.ClosePath(pList));
      });
    }

    // 現在の階の建具の情報を足す
    const wallList: marietta.webcad.item.WallObject[] = marietta.webcad.WebCADGlobal.layerGroup.getTypeLayerInFloorLayer(marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor, ITEM_MODE_NO.MODE_WALL_NO).getAllChildren();
    const wallPointList: any[] = marietta.webcad.WebCADGlobal.webcad2Dmanager.getAllWallPointList(wallList);
    for (let i: number = 0; i < wallPointList.length; i += 1) {
      marietta.webcad.WebCADGlobal.scene.add(new graphicLibs.objects.Line(new THREE.Vector2(wallPointList[i][0].x, wallPointList[i][0].y), new THREE.Vector2(wallPointList[i][1].x, wallPointList[i][1].y)));
    }

    //入力のドットリスト
    let currentdotList = this.dotList.map((d: marietta.core.Point) => d.clone());

    // just add lines for the lines this controller creates
    if (this.dotList[0].distanceTo(this.dotList[this.dotList.length - 1]) !== 0) this.dotList.push(this.dotList[0].clone());
    for (let i = 1; i < this.dotList.length; i += 1) {
      marietta.webcad.WebCADGlobal.scene.add(new graphicLibs.objects.Line(new THREE.Vector2(this.dotList[i - 1].x, this.dotList[i - 1].y), new THREE.Vector2(this.dotList[i].x, this.dotList[i].y)));
    }
    const polyList = marietta.webcad.WebCADGlobal.scene.geometoryBuilder.area();
    const branch = marietta.webcad.WebCADGlobal.scene.geometoryBuilder.graph.branch();
    const outerList = marietta.webcad.WebCADGlobal.scene.geometoryBuilder.outer();

    const { points } = marietta.webcad.WebCADGlobal.scene.geometoryBuilder.pointlist;
    const outerPoints = []; // 外側のポイントリスト
    outerList.forEach((outer: number[]) => {
      for (let i = 1; i <= outer.length; i += 1) {
        outerPoints.push({ p1: points[outer[i - 1]], p2: points[outer[i % outer.length]] });
      }
    });

    const targetFloor: marietta.webcad.layer.FloorLayer = marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor);
    targetFloor.formatLayersNewRoomCreations();
    const areaPoints = [];
    const guidList = [];
    const usedOldRoomIndexes = [];
    //新しい配列を元に部屋を生成する
    for (let i: number = 0; i < polyList.length; i += 1) {
      if (polyList[i].length < 3) continue;

      let info: marietta.webcad.collection.ItemInfoCollection = new marietta.webcad.collection.ItemInfoCollection();

      //新しい頂点リスト
      const dotList = marietta.webcad.util.WebCADUtil.convertPointListToRoomDotList(polyList[i]);

      // 部屋面積ほぼゼロチェック
      if (marietta.webcad.util.WebCADUtil.isAreaZero(dotList)) continue;

      const existingRoomInfo = marietta.webcad.WebCADGlobal.webcad2Dmanager.retrieveAreaInfo(roomList, dotList, usedOldRoomIndexes);

      for (let j = 0; j < polyList[i].length - 1; j += 1) {
        areaPoints.push({ p1: polyList[i][j], p2: polyList[i][j + 1] });
      }
      areaPoints.push({ p1: polyList[i][polyList[i].length - 1], p2: polyList[i][0] });

      // 頂点が作成時の頂点と全く同一の場合
      if (marietta.webcad.util.WebCADUtil.checkAllPointsExistInDotList(this.dotList, dotList)) {
        existingRoomInfo.info = null;
      }

      if (existingRoomInfo.info != null) {
        const createdRoom = marietta.webcad.util.WebCADUtil.checkAllPointsExistInDotList(currentdotList, dotList);
        if (createdRoom) {
          info.x = 0;
          info.y = 0;
          info.guid = marietta.webcad.WebCADGlobal.getGuid();
          info.id = String((<HTMLInputElement>document.getElementById('roomInputMenuItems').querySelector('input[type="radio"]:checked')).value);
          info.dotList = [];
          let dot: marietta.webcad.collection.PointCollection;
          const defaultRoomSetting = marietta.webcad.WebCADGlobal.getRoomConfig(info.id);
          for (let k: number = 0; k < dotList.length; k += 1) {
            dot = new marietta.webcad.collection.PointCollection(
              CalculationUtil.roundValue(dotList[k].x - info.x),
              CalculationUtil.roundValue(dotList[k].y - info.y),
              defaultRoomSetting.wallType,
              dotList[k].guid
            );
            info.dotList.push(dot);
          }

          const textPos = new graphicLibs.utility.labelPosition().labelPosition(polyList[i]);
          info.textPosition = new marietta.core.Point(textPos.x, textPos.y);
        } else {
          info = existingRoomInfo.info.clone();
          marietta.webcad.WebCADGlobal.webcad2Dmanager.retrieveRoomWallInfo(info.globalDotList, dotList);
          info.index = undefined;
          info.x = 0;
          info.y = 0;
          console.log(info.guid);
          if (guidList.indexOf(info.guid) > -1 || existingRoomInfo.hasShapeChange) {
            info.guid = marietta.webcad.WebCADGlobal.getGuid();
          }
          info.dotList = [];
          let dot: marietta.webcad.collection.PointCollection;
          for (let k: number = 0; k < dotList.length; k += 1) {
            dot = new marietta.webcad.collection.PointCollection(
              CalculationUtil.roundValue(dotList[k].x - info.x),
              CalculationUtil.roundValue(dotList[k].y - info.y),
              dotList[k].wall_type, dotList[k].guid
            );
            info.dotList.push(dot);
          }
        }
      } else {
        info.x = 0;
        info.y = 0;
        info.guid = marietta.webcad.WebCADGlobal.getGuid();
        info.id = String((<HTMLInputElement>document.getElementById('roomInputMenuItems').querySelector('input[type="radio"]:checked')).value);
        info.dotList = [];
        let dot: marietta.webcad.collection.PointCollection;
        const defaultRoomSetting = marietta.webcad.WebCADGlobal.getRoomConfig(info.id);
        for (let k: number = 0; k < dotList.length; k += 1) {
          dot = new marietta.webcad.collection.PointCollection(
            CalculationUtil.roundValue(dotList[k].x - info.x),
            CalculationUtil.roundValue(dotList[k].y - info.y),
            defaultRoomSetting.wallType, dotList[k].guid
          );
          info.dotList.push(dot);
        }

        const textPos = new graphicLibs.utility.labelPosition().labelPosition(polyList[i]);
        info.textPosition = new marietta.core.Point(textPos.x, textPos.y);
      }
      guidList.push(info.guid);
      marietta.webcad.WebCADGlobal.itemManager.createItem(info);
    }
    const wallpoints = [];
    if (branch.length > 0) {
      const nodes = marietta.webcad.WebCADGlobal.scene.geometoryBuilder.graph.adjacencyList;
      nodes.forEach((pointList, index: number) => {
        const pos1: THREE.Vector2 = points[index];

        pointList.forEach((pointIndex: number) => {
          if (branch[index] !== -1) {
            // TODO:壁を書く
            if (!marietta.webcad.WebCADGlobal.webcad2Dmanager.isSimilarLine({ p1: pos1, p2: points[pointIndex] }, wallpoints) && !marietta.webcad.WebCADGlobal.webcad2Dmanager.isSimilarLine({ p1: pos1, p2: points[pointIndex] }, areaPoints)) {
              let info: marietta.webcad.collection.ItemInfoCollection = new marietta.webcad.collection.ItemInfoCollection();
              info.x = 0;
              info.y = 0;
              info.id = 'wal01_01';
              info.dotList = [new PointCollection(pos1.x, pos1.y), new PointCollection(points[pointIndex].x, points[pointIndex].y)];
              const oldInfo = marietta.webcad.WebCADGlobal.webcad2Dmanager.retrieveWallObjectInfo(wallList, info.dotList);
              if (oldInfo != null) {
                info = oldInfo.clone();
              } else {
                info.guid = marietta.webcad.WebCADGlobal.getGuid();
              }
              marietta.webcad.WebCADGlobal.itemManager.createItem(info);
              wallpoints.push({ p1: pos1, p2: points[pointIndex] });
            }
          }
        });
      });
    }

    const missingWalls = marietta.webcad.WebCADGlobal.webcad2Dmanager.findMissingWall(areaPoints, wallpoints, outerPoints); // 壁リストに含まれていない壁があるかどうかを確認
    if (missingWalls.length > 0) {
      missingWalls.forEach((wall: any) => {
        let info: marietta.webcad.collection.ItemInfoCollection = new marietta.webcad.collection.ItemInfoCollection();
        info.x = 0;
        info.y = 0;
        info.id = 'wal01_01';
        info.dotList = [new PointCollection(wall.p1.x, wall.p1.y), new PointCollection(wall.p2.x, wall.p2.y)];
        const oldInfo = marietta.webcad.WebCADGlobal.webcad2Dmanager.retrieveWallObjectInfo(wallList, info.dotList);
        if (oldInfo != null) {
          info = oldInfo.clone();
        } else {
          info.guid = marietta.webcad.WebCADGlobal.getGuid();
        }

        marietta.webcad.WebCADGlobal.itemManager.createItem(info);
      });
    }

    marietta.webcad.WebCADGlobal.webcad2Dmanager.updateWallList();

    this.dotList = [];
    marietta.webcad.WebCADGlobal.webcad2Dmanager.isParsingObjects = false;
    marietta.webcad.WebCADGlobal.cadAPIManager.MakeRoomWall();
    marietta.webcad.WebCADGlobal.updateMeasureLine(false, false);
  }

  /** 分割しない部屋の作成 */
  private handleRoomCreation() {
    // アイテム情報の作成
    let dot: marietta.webcad.collection.PointCollection;
    const info: marietta.webcad.collection.ItemInfoCollection = new marietta.webcad.collection.ItemInfoCollection();
    info.guid = marietta.webcad.WebCADGlobal.getGuid();
    info.x = this.dotList[0].x;
    info.y = this.dotList[0].y;
    // 現在選択されている部屋種類の取得

    // アイテムメニューUI変更のため、仕様変更 20160601 森本 start
    info.id = String((<HTMLInputElement>document.getElementById('roomInputMenuItems').querySelector('input[type="radio"]:checked')).value);
    // アイテムメニューUI変更のため、仕様変更 20160601 森本 end
    info.dotList = [];

    const defaultRoomSetting = marietta.webcad.WebCADGlobal.getRoomConfig(info.id);
    for (let i: number = 0; i < this.dotList.length; i += 1) {
      dot = new marietta.webcad.collection.PointCollection(
        CalculationUtil.roundValue(this.dotList[i].x - info.x),
        CalculationUtil.roundValue(this.dotList[i].y - info.y),
        defaultRoomSetting.wallType);
      dot.guid = marietta.webcad.WebCADGlobal.getGuid();
      info.dotList.push(dot);
    }
    if (info.id === 'bem01_01') info.height = 300;
    // 作成s
    const item = marietta.webcad.WebCADGlobal.itemManager.createItem(info);
    // 部屋面積ほぼゼロチェック
    if (marietta.webcad.util.WebCADUtil.isAreaZero(info.dotList)) {
      item.deleteMe();
    }

    marietta.webcad.WebCADGlobal.webcad2Dmanager.updateWallList();
  }

  /** 部屋作成後の処理 */
  private finalizeShapeCreation() {
    // //スナップリストの作成
    marietta.webcad.WebCADGlobal.snapManager.updateSnapElements();
    marietta.webcad.WebCADGlobal.quotationItemList.createData();
    this.removeEventListeners();

    // 作成用モジュールなど削除する
    this.clean();

    //見積リスト更新
    marietta.webcad.WebCADGlobal.quotationItemList.createData(true);

    marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();

    // 連続入力モード判別
    if (marietta.webcad.WebCADGlobal.webcad2Dmanager.continualInput) {
      marietta.webcad.WebCADGlobal.itemManager.currentItem = null;
      const actionMode = marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode;
      marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode = actionMode;
    } else {
      marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode = CONTROL_ACTIONMODE.ACTIONMODE_SELECT_ITEM;
      // 部屋種類ラジオボタンのチェックをはずす
      const checkboxes = document.getElementById('roomInputMenuItems').querySelectorAll('input[type="radio"]');
      for (let i = 0; i < checkboxes.length; i += 1) {
        (<HTMLInputElement>checkboxes[i]).checked = false;
      }
    }
  }

  /**
   * 作成用モジュールなど削除する
   */
  clean() {
    if (this.dragImage) {
      this.dragImage.remove();
    }
    this.dragImage = null;
    if (document.getElementById('controller_snap_guide')) {
      document.getElementById('controller_snap_guide').remove();
    }
  }

  interrupt() {
    this.clean();
    if (this.snapSpt) {
      this.snapSpt.deleteEnterFrame();
      this.snapSpt.element.remove();
    }
  }
}
export default ItemControllerRoomDragInput;
